import React from 'react'
import PageApp from '../../../Page';
import {Table, Empty, Tag, Dropdown, Modal, Divider, message} from 'antd';
import {getAll, drop} from '../../../../apis/UsersApi';
import { HomeOutlined, UserOutlined, ExclamationCircleFilled, UnorderedListOutlined } from '@ant-design/icons';
import AddUser from './add';
import EditUser from './edit';
const { confirm } = Modal;

const UsersPage = () => {
  const [items, setItems] = React.useState([]);
  const [showEdit, setShowEdit] = React.useState(false);
  const [userId, setUserId] = React.useState(false);

  const onMenuClick = async (e, item) => {
    if(e.key == "delete"){
      await deleteConfirm(item);
      return;
    }
  };

  const deleteConfirm = async (item) => {
    confirm({
      title: '¿Confirmas en eliminar el usuario?',
      icon: <ExclamationCircleFilled />,
      content: 'No podrás recuperar su información',
      onOk: ()=>{deleteUserOk(item.id)},
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const deleteUserOk = async (id)=>{
    const response = await drop(id);
    if(response.ok){
      message.error('¡El usuario ha sido eliminadó!');
    }
    await refreshData();
  }

  const onEditClick = async (item)=>{
    setUserId(item.public_id);
    setShowEdit(true);
  }

  const saveEditHandler = async (response)=>{
    setShowEdit(false);
    refreshData();
  }

  const saveAddHandler = async (response)=>{
    refreshData();
  }

  const closeEditModal = async ()=> {
    setShowEdit(false);
  }

  const routes = [  {
    href: '',
    title: <>
      <HomeOutlined />
      <span>Inicio</span>
    </>,
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Configuración</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>General</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <UserOutlined />
        <span>Usuarios</span>
      </>
    ),
  }];
  
  const columns = [
    {
      title: 'Correo',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Nombre',
      dataIndex: 'first_name',
      key: 'first_name',
    },
    {
      title: 'Apellido',
      dataIndex: 'last_name',
      key: 'last_name',
    },
    {
      title: 'Rol',
      dataIndex: 'role_id',
      key: 'role_id',
      render: (item, object)=>{
        switch(object.role_id){
          case 1: 
            return  <Tag color="green">Común</Tag>;
          case 100: 
            return  <Tag color="blue">Administrador</Tag>;
          case 3: 
            return  <Tag color="pink">Nominista</Tag>;
          case 4: 
            return  <Tag color="purple">Gerente de nomina</Tag>;
          default:
            return  <Tag color="cyan">Otro</Tag>
        }
      }
    },
    {
      title: '',
      dataIndex: 'actions',
      key: 'actions',
      render: (item, object)=>{
        //Si el usuario es de rol "Otro", no le permitimos hacer nada
        if(![1,2].includes(object.role_id)){
          return <></>
        }

        return <Dropdown.Button
            onClick={(e)=> {onEditClick(object)}}
            menu={{
              items:[
                {
                  key: 'changepassword',
                  label: 'Cambiar Password',
                },
                {
                  key: 'delete',
                  label: 'Eliminar',
                },
              ],
              onClick: (e)=> {onMenuClick(e,object)},
            }}
        >Editar</Dropdown.Button>
      }
    }
  ];

  const effectRan = React.useRef(false);
  React.useEffect(() => {
    if (!effectRan.current) {
      (async () => {
        await refreshData();
      })();
    }
    return () => effectRan.current = true;
  }, []);

  const refreshData = async ()=> {
    const response = await getAll();
    if(response.ok){
      let items = response.payload;
      setItems(items);
    }
  }
  
  return <PageApp routes={routes} title={"Usuarios"}>
    <AddUser saveFn={saveAddHandler}></AddUser>
    {
      (showEdit && userId) && <EditUser id={userId} closeFn={closeEditModal} deleteFn={deleteConfirm} saveFn={saveEditHandler}></EditUser>
    }
    <Divider/>
    {
      items.length == 0 ? <Empty />:
      <Table dataSource={items} columns={columns} />
    }

  </PageApp>
};

export default UsersPage;